<template>
    <section id="travailler" class="Work">
      <div class="Work__header">
        <h2 class="Work__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Pour travailler</h2>
        <p v-if="text" class="Work__lead raleway-reg-p15">
          {{ text }}
        </p>
      </div>
  
      <div class="Work__railWrap">
        <button
          v-show="showArrows"
          class="Work__arrow Work__arrow--left"
          type="button"
          aria-label="Précédent"
          @click="scrollBy(-1)"
        >
          ‹
        </button>
  
        <div class="Work__rail" ref="rail">
          <div
            v-for="(src, i) in images"
            :key="i"
            class="Work__item"
          >
            <img :src="src" :alt="`Photo espace de travail ${i + 1}`" loading="lazy" />
          </div>
        </div>
  
        <button
          v-show="showArrows"
          class="Work__arrow Work__arrow--right"
          type="button"
          aria-label="Suivant"
          @click="scrollBy(1)"
        >
          ›
        </button>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'WorkSection',
    props: {
      text:   { type: String, default: '' },
      images: { type: Array,  default: () => [] }
    },
    data() {
      return {
        isPhone: window.innerWidth < 768
      }
    },
    computed: {
      showArrows () {
        return window.matchMedia('(min-width: 900px)').matches && this.images.length > 2;
      }
    },
    methods: {
      scrollBy (dir = 1) {
        const el = this.$refs.rail;
        if (!el) return;
        const card = el.querySelector('.Work__item');
        const step = card ? card.clientWidth + 16 : el.clientWidth * 0.75;
        el.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
    }
  }
  </script>
  
  <style>
  .Work {
    padding: clamp(28px, 5vw, 56px) clamp(16px, 4vw, 28px);
    max-width: 1400px;
    margin: 0 auto;
  }
  .Work__header {
    text-align: center;
    max-width: 920px;
    margin: 0 auto clamp(16px, 3vw, 28px);
  }
  .Work__title {
    margin: 0 0 10px 0;
  }
  .Work__lead {
    margin: 0;
    line-height: 1.7;
    color: #2c2c2c;
  }
  
  .Work__railWrap {
    position: relative;
  }
  .Work__rail {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: clamp(78vw, 46vw, 420px); 
    gap: 16px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 6px;
  }
  .Work__rail::-webkit-scrollbar { height: 8px; }
  .Work__rail::-webkit-scrollbar-thumb { background: #d3d3d3; border-radius: 8px; }
  .Work__rail::-webkit-scrollbar-track { background: transparent; }
  
  .Work__item {
    scroll-snap-align: start;
    border-radius: 12px;
    overflow: hidden;
    background: #f6f6f6;
    height: clamp(220px, 38vw, 420px);
  }
  .Work__item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  
  .Work__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: 1px solid rgba(0,0,0,.15);
    background: rgba(255,255,255,.9);
    box-shadow: 0 2px 8px rgba(0,0,0,.08);
    cursor: pointer;
    font-size: 26px;
    font-family: 'Raleway', sans-serif;
    line-height: 1;
    display: none;
  }
  .Work__arrow--left  { left: 6px; }
  .Work__arrow--right { right: 6px; }
  
  @media (min-width: 900px) {
    .Work__rail { grid-auto-columns: minmax(340px, 1fr); }
    .Work__arrow { display: inline-flex; align-items:center; justify-content:center; }
  }
  </style>  